"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeDatePicker = void 0;
const React = require("react");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const format_1 = require("../modules/format");
const theme_1 = require("../modules/theme");
const react_date_range_1 = require("react-date-range");
const Modal_1 = require("./Modal");
const layout_1 = require("../modules/layout");
require("react-date-range/dist/styles.css");
const react_native_1 = require("react-native");
require("../../styles/RangeDatePicker.css");
class RangeDatePicker extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            showStartDateModal: false,
            count: 0
        };
        this.calendarRef = React.createRef();
        this.handleClick = (event) => {
            if (this.calendarRef.current &&
                !this.calendarRef.current.contains(event.target)) {
                this.setState({ showStartDateModal: false, count: 0 });
            }
        };
        this.handleDatePickerPress = () => {
            this.setState({
                showStartDateModal: true
            });
        };
        this.handleRangeDateConfirm = (ranges) => {
            if (this.state.count == 1) {
                this.props.onStartDateChange(ranges.selection.startDate);
                // Sometimes the parent component is not ready because the setState method
                // is async, so we wait a little.
                setTimeout(() => this.props.onEndDateChange(ranges.selection.endDate), 1);
                this.setState({ showStartDateModal: false, count: 0 });
                return;
            }
            this.props.onStartDateChange(ranges.selection.startDate);
            this.setState({ count: 1 });
        };
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    paddingHorizontal: 16,
                    paddingVertical: 8,
                    borderWidth: 1,
                    borderColor: theme.borderColor1,
                    borderRadius: 3,
                    flexDirection: 'row',
                    alignItems: 'center'
                },
                modalOverlay: {
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                label: {
                    color: theme.textColor2,
                    fontFamily: theme.fontFamily3,
                    fontSize: (0, layout_1.isTablet)() ? 15 : 12,
                    lineHeight: 16
                },
                value: {
                    color: theme.textColor1,
                    fontFamily: theme.fontFamily1,
                    fontSize: 16,
                    lineHeight: 22
                },
                icon: {
                    marginLeft: 'auto',
                    color: theme.textColor2,
                    fontSize: 22
                }
            });
            return styles;
        };
    }
    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }
    render() {
        const { label, startDate, endDate, style, nativeID } = this.props;
        const { showStartDateModal } = this.state;
        const displayFormat = 'MMM d, yyyy';
        const displayText = (0, format_1.formatDate)(startDate, displayFormat) +
            ' - ' +
            (0, format_1.formatDate)(endDate, displayFormat);
        const theme = (0, theme_1.getTheme)();
        const styles = this.getStyles();
        return (React.createElement(react_native_1.TouchableWithoutFeedback, { onPress: this.handleDatePickerPress },
            React.createElement(react_native_1.View, { nativeID: nativeID, style: [styles.container, style] },
                React.createElement(react_native_1.View, null,
                    React.createElement(react_native_1.Text, { style: styles.label }, label),
                    React.createElement(react_native_1.Text, { style: styles.value }, displayText)),
                React.createElement(FontAwesome_1.default, { name: "calendar", style: styles.icon }),
                React.createElement(Modal_1.Modal, { visible: showStartDateModal, overlayStyle: styles.modalOverlay },
                    React.createElement("div", { ref: this.calendarRef, style: {
                            borderRadius: '5px',
                            position: 'absolute',
                            top: '50%',
                            marginTop: '-150px',
                            fontFamily: theme.fontFamily1
                        } },
                        React.createElement(react_date_range_1.DateRange, { locale: (0, format_1.getDateFnsLocale)(), showDateDisplay: false, ranges: [
                                {
                                    startDate: startDate,
                                    endDate: endDate,
                                    key: 'selection'
                                }
                            ], rangeColors: [theme.backgroundColor3], onChange: this.handleRangeDateConfirm, weekdayDisplayFormat: (0, format_1.getLocale)() === 'pt' ? 'EEEEEE' : 'E' }))))));
    }
}
exports.RangeDatePicker = RangeDatePicker;
